import PropTypes from 'prop-types'
export * from 'shop/shapes'

export const FarmListFromServerShape = {
  list: PropTypes.arrayOf(PropTypes.shape(FarmShape)),
  error: PropTypes.string,
  isFetching: PropTypes.bool
}

export const FarmShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  freight_farm: PropTypes.bool.isRequired,
  farmInstallationId: PropTypes.string.isRequired,
  remoteEnabled: PropTypes.bool.isRequired,
  box_ip: PropTypes.string.isRequired,
  box_port: PropTypes.string.isRequired,
  hub: PropTypes.shape({
    xivelyDeviceId: PropTypes.string.isRequired
  }),
  lastCheckIn: PropTypes.instanceOf(Date)
}

const BasicFromServerShape = {
  data: PropTypes.object,
  error: PropTypes.string,
  isFetching: PropTypes.bool
}

export const FarmFromServerShape = {
  ...BasicFromServerShape,
  data: PropTypes.shape(FarmShape)
}

// TODO: define these better
export const GroupFromServerShape = BasicFromServerShape
export const UserFromServerShape = BasicFromServerShape
export const SensorsFromServerShape = BasicFromServerShape
export const OutputsFromServerShape = BasicFromServerShape
export const InputsFromServerShape = BasicFromServerShape
export const HistoricalSensorDataFromServerShape = {
  ...BasicFromServerShape,
  data: PropTypes.array
}

export const ImageListFromServerShape = {
  list: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    createdAt: PropTypes.object
  })),
  error: PropTypes.string,
  isFetching: PropTypes.bool
}

const SimpleGroupShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  isOnline: PropTypes.bool
}

export const SimpleListGroupShape = PropTypes.arrayOf(PropTypes.shape(SimpleGroupShape))

export const SimpleGroupListFromServerShape = {
  list: SimpleListGroupShape,
  error: PropTypes.string,
  isFetching: PropTypes.bool.isRequired
}

export const PasswordResetShape = {
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.string,
  success: PropTypes.string
}

export const ChildrenShape = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node
])

export const ConnectivityLogShape = PropTypes.shape({
  sensorsOnline: PropTypes.bool.isRequired,
  createdAt: PropTypes.instanceOf(Date).isRequired
})

export const ConnectivityLogFromServer = PropTypes.shape({
  data: PropTypes.arrayOf(ConnectivityLogShape),
  error: PropTypes.string,
  isFetching: PropTypes.bool

})



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/shapes/index.js